// Geometry for a categorical axis, where category i occupies the lane
// [i - 0.5, i + 0.5] in axis data space. Dividers sit on the lane boundaries
// (the "bin range") rather than on the category centers, so adjacent categories
// read as distinct columns; alternating bands shade every other lane.

interface CategoryBand {
  index: number
  start: number
  end: number
}

// Interior lane boundaries between adjacent categories. The outer edges are
// omitted — the axis domain already bounds them.
export function categoryDividers(categoryCount: number): number[] {
  const dividers: number[] = []
  for (let i = 1; i < categoryCount; i++) {
    dividers.push(i - 0.5)
  }
  return dividers
}

// Every other lane, starting at the second, for subtle alternating shading.
export function alternatingBands(categoryCount: number): CategoryBand[] {
  const bands: CategoryBand[] = []
  for (let i = 1; i < categoryCount; i += 2) {
    bands.push({ index: i, start: i - 0.5, end: i + 0.5 })
  }
  return bands
}
